import { Box } from "@modernary/ui-kit-core";
import React from "react";

const SearchError = ({ error }) => {
  return <Box p="small">{error}</Box>;
};

export default SearchError;
